import { ScanSearch } from 'lucide-react'
import { QualityOverlay } from '@/tools/quality/QualityOverlay'
import { ToolKind, UtilityId, type UtilityTool } from '@/tools/types'

export const QUALITY_TOOL = {
  id: UtilityId.Quality,
  kind: ToolKind.Utility,
  label: 'Compare quality',
  icon: ScanSearch,
  Overlay: QualityOverlay,
} satisfies UtilityTool
